var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuildings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 14H2.66667M14 14H13.3333M2.66667 14V5.2C2.66667 4.07989 2.66667 3.51984 2.88465 3.09202C3.0764 2.71569 3.38236 2.40973 3.75869 2.21799C4.18651 2 4.74656 2 5.86667 2H6.13333C7.25344 2 7.81349 2 8.24131 2.21799C8.61764 2.40973 8.9236 2.71569 9.11535 3.09202C9.33333 3.51984 9.33333 4.07989 9.33333 5.2V5.33333M2.66667 14H6H9.33333M9.33333 14V5.33333M9.33333 14H13.3333M9.33333 5.33333H11.7333C12.2934 5.33333 12.5734 5.33333 12.7873 5.44233C12.9755 5.5382 13.1285 5.69118 13.2243 5.87934C13.3333 6.09325 13.3333 6.37328 13.3333 6.93333V14M11.3333 7.99333V8M11.3333 11.3333V11.34",
    stroke: "#000536",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3335 4.66699H6.66683M5.3335 8.00033H6.66683M5.3335 11.3337H6.66683",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildings);
export default __webpack_public_path__ + "static/media/buildings.68501191fdb069a62af77d57bbc549f7.svg";
export { ForwardRef as ReactComponent };